export default "__VITE_PUBLIC_ASSET__a9a829d9__"